import { useTranslation } from 'next-i18next';

const MobileSection = () => {
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });
  const { t: tHeroLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$hero' });
  const { t: tBeddingLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bedding' });

  return (
    <div className="mobile-cta">
      <div className="top">
        <a href={tHeroLinks('sleep')} className="base-link">
          <h2 className="font-body">{tCategory('sleep')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-sleep.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('sleep')}
              loading="eager"
              decoding="async"
              fetchPriority="high"
              width="684"
              height="300"
            />
          </picture>
        </a>
      </div>
      <div className="left-colm">
        <a href={tHeroLinks('robes')} className="base-link">
          <h2 className="font-body">{tCategory('robes')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-robes.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('robes')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="384"
            />
          </picture>
        </a>
        <a href={tBeddingLinks('throws')} className="base-link throws">
          <h2 className="font-body">{tCategory('throws')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-fur-throw.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('throws')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="382"
            />
          </picture>
        </a>
        <a href={tHeroLinks('fragrance')} className="base-link">
          <h2 className="font-body">{tCategory('fragrance')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-fragrance-compilation.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('fragrance')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="233"
            />
          </picture>
        </a>
      </div>
      <div className="right-colm">
        <a href={tHeroLinks('artistSeries')} className="base-link">
          <h2 className="font-body">{tCategory('artistSeries')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-artist-series.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('artistSeries')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="233"
            />
          </picture>
        </a>
        <a href={tHeroLinks('bath')} className="base-link">
          <h2 className="font-body">{tCategory('bath')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-le-labo.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('bath')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="233"
            />
          </picture>
        </a>
        <a href={tHeroLinks('linens')} className="base-link">
          <h2 className="font-body">{tCategory('linens')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-linens.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('linens')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="233"
            />
          </picture>
        </a>
        <a href={tHeroLinks('limitedEdition')} className="base-link">
          <h2 className="font-body">{tCategory('limitedEdition')}</h2>
          <picture>
            <source
              srcSet="/images/homePage/mobileSection/mob_edition-limited.jpg"
              media="(max-width: 660px)"
            />
            <img
              src="/images/misc/fill.gif"
              aria-hidden="true"
              alt={tCategory('limitedEdition')}
              loading="eager"
              decoding="async"
              fetchPriority="low"
              width="340"
              height="233"
            />
          </picture>
        </a>
      </div>
    </div>
  );
};

export default MobileSection;
